export default __webpack_public_path__ + "static/bullet_header-d48f38ee55a9e163fee3824cb860c458.webp";